export interface LoginResponseDto {
  sessionKey?: string;
  redirectUrl?: string;
  user?: UserDto;
  requiresBlockedUnblockVerification: boolean;
  maskedPhoneNumber?: string | null;
}
export interface LoginRequestDto {
  username: string;
  password: string;
  captchaToken: string;
}
export interface SendVerificationCodeRequestDto {
  username: string;
  password: string;
  verificationType: VerificationTypes;
}
export interface SendBlockedUnblockVerificationCodeRequestDto {
  username: string;
  password: string;
}
export interface SendVerificationCodeResponseDto {
  verificationSeconds: number;
}
export interface CheckVerificationCodeResponseDto {
  sessionKey: string;
  redirectUrl: string;
  user: UserDto;
}

export interface CheckVerificationCodeRequestDto {
  username: string;
  password: string;
  verificationType: VerificationTypes;
  verificationCode: string;
  clientId: string | null;
}
export interface CheckBlockedUnblockVerificationCodeRequestDto {
  username: string;
  password: string;
  verificationCode: string;
}
export interface UserDto {
  username: string;
  email: string;
  userRoles: number[];
}

export enum Roles {
  admin = 1,
  user = 2,
}

export enum VerificationTypes {
  Sms = 1,
  Email = 2,
}
